let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kL5dh")).then(() => parcelRequire('28gf5'));